import React from "react";

// Lazy routes with one honest retry.
//
// A chunk fails to load for two reasons: a transient network blip, or a
// deploy that replaced the build while this tab was open (the new nginx
// image no longer serves the old chunk hashes — the ChunkLoadError that made
// the first lazy-route attempt, 89b78ee, get reverted). Strategy:
//
//   1. retry the import ONCE after a short pause — that clears blips;
//   2. if it fails again, tag the error and let it reach ChunkErrorBoundary,
//      which shows "Chariot was updated — Reload" and waits for the USER.
//
// Never reload automatically: a forced reload silently discards whatever the
// user was typing. The reload is one click away, and the page's own
// unsaved-changes guard still gets to speak on it.
const isChunkLoadError = (err) =>
  err?.name === "ChunkLoadError" ||
  /Loading (CSS )?chunk|Failed to fetch dynamically imported module|import\(\) failed/i.test(err?.message || "");

const pause = (ms) => new Promise((r) => setTimeout(r, ms));

export default function lazyWithRetry(importer) {
  return React.lazy(async () => {
    try {
      return await importer();
    } catch (first) {
      if (!isChunkLoadError(first)) throw first;
      await pause(1500);
      try {
        return await importer();
      } catch (second) {
        if (isChunkLoadError(second)) second.isChunkLoadError = true;
        throw second;
      }
    }
  });
}
